module.exports = __webpack_public_path__ + "img/nav_item_bg1-active.afc27544.png";